import { get, post, put, del } from '../utils/makeRequest';

const BLOG_ENDPOINTS = {
  GET_BLOGS: '/admin/get-blogs',
  CREATE_BLOG: '/admin/create-blog',
  EDIT_BLOG: '/admin/edit-blog',
  UPDATE_BLOG: '/admin/update-blog',
  DELETE_BLOG: '/admin/delete-blog',
  // Public endpoints
  GET_PUBLIC_BLOGS: '/blogs',
  GET_PUBLIC_BLOG_BY_ID: '/blogs',
};

export const blogService = {
  /**
   * Get all blogs (public)
   * @returns {Promise} - List of blogs
   */
  getBlogs: async () => {
    return get(BLOG_ENDPOINTS.GET_PUBLIC_BLOGS);
  },

  /**
   * Get blog by ID (public)
   * @param {string} blogId - Blog ID
   * @returns {Promise} - Blog data
   */
  getBlogById: async (blogId) => {
    return get(`${BLOG_ENDPOINTS.GET_PUBLIC_BLOG_BY_ID}/${blogId}`);
  },

  /**
   * Create a new blog
   * @param {object} blogData - Blog data including title, content, and featured image
   * @returns {Promise} - Created blog data
   */
  createBlog: async (blogData) => {
    try {
      const formData = new FormData();
      formData.append('title', blogData.title);
      formData.append('content', blogData.content);
      
      // Handle featured image upload
      if (blogData.featured_image && blogData.featured_image instanceof File) {
        formData.append('image', blogData.featured_image);
        console.log('Appending featured image to FormData:', blogData.featured_image.name);
      }
      
      console.log('FormData entries:');
      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
          console.log(key, ':', { name: value.name, size: value.size, type: value.type });
        } else {
          console.log(key, ':', value);
        }
      }
      
      const response = await post(BLOG_ENDPOINTS.CREATE_BLOG, formData);
      console.log('Blog creation response:', response);
      return response;
    } catch (error) {
      console.error('Error in createBlog service:', error);
      console.error('Error response:', error.response);
      throw error;
    }
  },

  /**
   * Get blog by ID (admin)
   * @param {string} blogId - Blog ID
   * @returns {Promise} - Blog data
   */
  getBlogByIdAdmin: async (blogId) => {
    return get(`${BLOG_ENDPOINTS.EDIT_BLOG}/${blogId}`);
  },

  /**
   * Update blog
   * @param {string} blogId - Blog ID
   * @param {object} blogData - Updated blog data
   * @returns {Promise} - Updated blog data
   */
  updateBlog: async (blogId, blogData) => {
    const formData = new FormData();
    formData.append('title', blogData.title);
    formData.append('content', blogData.content);
    
    // Handle featured image upload
    if (blogData.featured_image && blogData.featured_image instanceof File) {
      formData.append('image', blogData.featured_image);
      console.log('Appending featured image to FormData:', blogData.featured_image.name);
    }
    
    return put(`${BLOG_ENDPOINTS.UPDATE_BLOG}/${blogId}`, formData);
  },

  /**
   * Delete blog
   * @param {string} blogId - Blog ID
   * @returns {Promise} - Deletion result
   */
  deleteBlog: async (blogId) => {
    return del(`${BLOG_ENDPOINTS.DELETE_BLOG}/${blogId}`);
  },
}; 